"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    console.time('nc_073_file_reference_indexes');
    await knex.schema.alterTable(_globals.MetaTable.FILE_REFERENCES, (table)=>{
        table.index([
            'base_id',
            'fk_workspace_id'
        ], 'nc_fr_context');
    });
    await knex.schema.alterTable(_globals.MetaTable.FILE_REFERENCES, (table)=>{
        // this index is used on migration, so we are dropping it now
        if (!knex.client.config.client.includes('mysql')) {
            table.dropIndex([
                'file_url',
                'storage'
            ], 'nc_file_references_temp');
        }
    });
    console.timeEnd('nc_073_file_reference_indexes');
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.FILE_REFERENCES, (table)=>{
        table.dropIndex('nc_fr_context');
    });
    await knex.schema.alterTable(_globals.MetaTable.FILE_REFERENCES, (table)=>{
        table.index([
            'file_url',
            'storage'
        ], 'nc_file_references_temp');
    });
};
